import { request, METHOD } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/**
 * #10056 到货通知列表
  GET /product/notice/setting/list
  接口ID：220394672
  接口地址：https://app.apifox.com/link/project/3032888/apis/api-220394672
 * @param   data
 * @return
 */
export function getNoticeList(data) {
  return request("".concat(BASE_URL) + "/product/notice/setting/list", METHOD.GET, data);
}

/**
 * #10057 复制到货通知
  PUT /product/notice/setting/copy/{id}
  接口ID：220394708
  接口地址：https://app.apifox.com/link/project/3032888/apis/api-220394708
 * @param  {number} id 复制的到货通知id
 * @return {Promise}
 */
export function copyNotice(id) {
  return request("".concat(BASE_URL) + "/product/notice/setting/copy/".concat(id), METHOD.PUT);
}

/**
	#10058	删除到货通知
  DELETE /product/notice/setting/{id}
  接口ID：220394713
  接口地址：https://app.apifox.com/link/project/3032888/apis/api-220394713
 * @param  {number} id 到货通知id
 * @return {Promise}
 */
export function deleteNotice(id) {
  return request("".concat(BASE_URL) + "/product/notice/setting/".concat(id), METHOD.DELETE);
}

/**
 * #10058 新建、保存到货通知信息
  PUT /product/notice/setting
  接口ID：220394745
  接口地址：https://app.apifox.com/link/project/3032888/apis/api-220394745
 * @param  {[type]} data [description]
 * @return {[type]}      [description]
 */
export function saveNoticeSetting(data) {
  return request("".concat(BASE_URL) + "/product/notice/setting", METHOD.PUT, data);
}

/**
 * #10059 查询到货通知信息
  GET /product/notice/setting/{id}
  接口ID：220394718
  接口地址：https://app.apifox.com/link/project/3032888/apis/api-220394718
 * @param  {[type]} id   [description]
 * @param  {[type]} data [description]
 * @return {[type]}      [description]
 */
export function getNoticeSetting(id, data) {
  return request("".concat(BASE_URL) + "/product/notice/setting/".concat(id), METHOD.GET, data);
}

/**
 * #10059 通知得意先
  POST /product/notice/setting/erpcustomer/{id}
  接口ID：220532697
  接口地址：https://app.apifox.com/link/project/3032888/apis/api-220532697
 * @param  {[type]} id   [description]
 * @param  {[type]} data [description]
 * @return {[type]}      [description]
 */
export function noticeDyx(id, data) {
  return request("".concat(BASE_URL) + "/product/notice/setting/erpcustomer/".concat(id), METHOD.POST, data);
}